import { v4 } from 'uuid'

import { createSelector } from '@app/utils/createSelector'

import type { ApiAccountIssue, ApiAccountIssueStep } from '@app/packages/api/v2/types/entities'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { profileUserResultSelector } from '@app/store/selectors/profile'

import { routingDateSelector } from './routing'

const accountIssuesSlice = createReduxSlice<SliceState<{ data: ApiAccountIssue[]; included: ApiAccountIssueStep[] }>>('account_issues')
const accountIssuesHashSlice = createReduxSlice<string>('account_issues_hash')

export const accountIssuesListSelector = createSelector(
  [accountIssuesSlice.selector, accountIssuesHashSlice.selector, profileUserResultSelector, routingDateSelector],
  (state, statehash, profileUserResult, date) =>
    createLoadable(c => {
      const user = c.unwrap(profileUserResult)
      if (!user || user.account_type === 'visitor') return { data: [], included: [] }

      const hash = [String(user.id), statehash ?? ''].join(':')

      return withCheckedSliceState(c, {
        sliceState: state,
        slice: accountIssuesSlice,
        hash,
        date: { date, expiresInMinutes: 30 },
        load: async dispatch => {
          const { getAccountIssues } = await import('@app/packages/api/v2/actions/account_issues')
          const resp = await dispatch(callV2Api(getAccountIssues()))
          return { data: resp.data, included: resp.included?.filter(e => e.type === 'account_issue_steps') ?? [] }
        },
      })
    })
)

export const invalidateAccountIssues = () => accountIssuesHashSlice.set(v4())
